import React, { FC } from 'react';
import MetadataTag from '../metadata-tag';
import CreateMetadata from 'components/metadata/create-metadata';
type StreakPauseReasonProps = {
  title: string;
  onCreate: (e: any) => void;
  list?: string[];
  onDelete: (id: string) => void;
  loading?: boolean;
  emptyText?: string;
};

const StreakPauseReasonList: FC<StreakPauseReasonProps> = ({
  title,
  onCreate,
  list = [],
  onDelete,
  loading,
  emptyText = 'No available items'
}) => {
  const handleCreate = (newItem: string) => {
    onCreate(newItem);
  };

  return (
    <div className='space-y-2'>
      <h3>{title}</h3>
      <div className='rounded-[12px] bg-[#F7F8F8] text-xs p-[6px]'>
        <CreateMetadata onEnter={handleCreate} />
        <div className='p-6 mt-2 bg-white rounded-lg'>
          {loading ? (
            <p className='py-6'>Loading...</p>
          ) : list.length === 0 ? (
            <p className='py-6'>{emptyText}</p>
          ) : (
            <ul className='flex items-center gap-4 justify-start flex-wrap'>
              {list.map((item, i) => {
                const itemName = typeof item === 'string' ? item : item;
                const itemId = typeof item === 'string' ? item : item;

                return (
                  <MetadataTag
                    hasDeleteBtn
                    color='gray'
                    name={itemName}
                    key={i}
                    onDelete={() => onDelete(itemId)}
                  />
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default StreakPauseReasonList;
